import React, { useReducer } from 'react';
import firebase from 'firebase';

import { firestoreInitialize } from 'config/firebase/client';

import SettingsBaseContext from './SettingsBaseContext';
import SettingsBaseReducer from './SettingsBaseReducer';

const SettingsBaseState = (props) => {
    const initialState = {
        getSettingsBase: {
            settingsBase: [],
            id: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateSettingsBase: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getCountries: {
            countries: [],
            firstCountry: null,
            lastCountry: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getCountriesById: {
            country: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createCountries: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateCountriesById: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getCurrenciesByCountry: {
            currencies: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createCurrenciesByCountry: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateCurrenciesById: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getCitiesByCountry: {
            cities: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createCitiesByCountry: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateCitiesByCountry: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
    };

    const [state, dispatch] = useReducer(SettingsBaseReducer, initialState);

    const getSettingsBase = () => {
        dispatch({ type: 'GET_SETTINGS_BASE_LOADING' });

        let db = firestoreInitialize();

        db.collectionGroup('Configuraciones')
            .get()
            .then((querySnapshot) => {
                dispatch({ type: 'GET_SETTINGS_BASE', payload: { data: querySnapshot.docs.map(doc => doc.data()), id: querySnapshot.docs.map(doc => doc.id) } });
            })
            .catch((error) => dispatch({ type: 'GET_SETTINGS_BASE_ERROR', payload: { code: 'settings/error', message: error } }))
    };

    const updateSettingsBase = (id, data) => {
        dispatch({ type: 'UPDATE_SETTINGS_BASE_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        let date = firebase.firestore.FieldValue.serverTimestamp();

        let docRef = db.collection("Configuraciones").doc(id)

        if (data.logo) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/logo-principal`).put(data.logo, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'UPDATE_SETTINGS_BASE_ERROR', payload: { code: 'settings/update-error', message: error } });
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    docRef.update({
                        nombreUsuarios: data.nameAllies,
                        nombreProveedores: data.nameProvider,
                        logo: downloadURL,
                        ultimaActualizacion: date
                    })
                    .then(() => {
                        dispatch({ type: 'UPDATE_SETTINGS_BASE' });
                    })
                    .catch((error) => {
                        dispatch({ type: 'UPDATE_SETTINGS_BASE_ERROR', payload: { code: 'settings/update-error', message: error } });
                    });
                });
            });
        } else {
            if (data.deleteLogo && data.logoPath.length > 0) {
                let storageRef = storage.refFromURL(data.logoPath);

                storageRef.delete().then(function() {
                    docRef.update({
                        nombreUsuarios: data.nameAllies,
                        nombreProveedores: data.nameProvider,
                        logo: "",
                        ultimaActualizacion: date
                    })
                    .then(() => {
                        dispatch({ type: 'UPDATE_SETTINGS_BASE' });
                    })
                    .catch((error) => {
                        dispatch({ type: 'UPDATE_SETTINGS_BASE_ERROR', payload: { code: 'settings/update-error', message: error } });
                    });
                }).catch(function(error) {
                    dispatch({ type: 'UPDATE_SETTINGS_BASE_ERROR', payload: { code: 'settings/update-error', message: error } });
                });
            } else {
                docRef.update({
                    nombreUsuarios: data.nameAllies,
                    nombreProveedores: data.nameProvider,
                    ultimaActualizacion: date
                })
                .then(() => {
                    dispatch({ type: 'UPDATE_SETTINGS_BASE' });
                })
                .catch((error) => {
                    dispatch({ type: 'UPDATE_SETTINGS_BASE_ERROR', payload: { code: 'settings/update-error', message: error } });
                });
            }
        }
    };

    const updateSettingsBaseResetState = () => {
        dispatch({ type: 'UPDATE_SETTINGS_BASE_RESET_STATE' });
    }
    
    const getCountries = () => {
        dispatch({ type: 'GET_COUNTRIES_LOADING' });

        let db = firestoreInitialize();

        db.collection('Ciudades')
            .get()
            .then((querySnapshot) => {
                dispatch({ type: 'GET_COUNTRIES', payload: { data: querySnapshot.docs.map(doc => doc.id), first: querySnapshot.docs[querySnapshot.docs.length=0], last: querySnapshot.docs[querySnapshot.docs.length-1]} });
            })
            .catch((error) => dispatch({ type: 'GET_COUNTRIES_ERROR', payload: { code: 'countries/error', message: error } }))
    };

    const getCurrenciesByCountry = (id) => {
        dispatch({ type: 'GET_CURRENCIES_LOADING' });

        let db = firestoreInitialize();

        db.collectionGroup('Configuraciones')
            .get()
            .then((querySnapshot) => {
                let data;

                querySnapshot.forEach((document) => {
                    document.ref.collection("Paises").doc(id).get().then((querySnapshot) => {
                        dispatch({ type: 'GET_COUNTRIES_BY_ID', payload: querySnapshot.data() })
                        
                        querySnapshot.ref.collection("Monedas").get().then((querySnapshot) => {
                            if (data) {
                                data = data.concat(querySnapshot.docs.map(doc => doc.data()))
                            } else {
                                data = querySnapshot.docs.map(doc => doc.data())
                            }
                            dispatch({ type: 'GET_CURRENCIES', payload: { data: data, first: querySnapshot.docs[querySnapshot.docs.length=0], last: querySnapshot.docs[querySnapshot.docs.length-1]} });
                        })
                    })
                })
            })
            .catch((error) => dispatch({ type: 'GET_CURRENCIES_ERROR', payload: { code: 'countries/error', message: error } }))
    };

    const createCountries = (data) => {
        dispatch({ type: 'CREATE_COUNTRIES_LOADING' });

        let db = firestoreInitialize();

        db.collectionGroup('Configuraciones')
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((document) => {
                    document.ref.collection("Paises").add({
                        nombre: data.name,
                        status: data.status,
                        codigoTelefono: data.code
                    })
                    .then((doc) => {
                        document.ref.collection("Paises").doc(doc.id).update({
                            paisId: doc.id
                        })
                        .then(() => {
                            dispatch({ type: 'CREATE_COUNTRIES' })
                        })
                    })
                })
            })
            .catch((error) => dispatch({ type: 'CREATE_COUNTRIES_ERROR', payload: { code: 'countries/error', message: error } }))
    };

    const createCountriesWithExcel = async (data) => {
        dispatch({ type: 'CREATE_COUNTRIES_LOADING' });

        let db = firestoreInitialize();

        await data.forEach((doc) => {
            db.collection("Ciudades").doc(doc.country).update({
                ciudades: doc.cities,
            })
            .catch((error) => dispatch({ type: 'CREATE_COUNTRIES_ERROR', payload: { code: 'countries/error', message: error } }))
        });

        dispatch({ type: 'CREATE_COUNTRIES' })
    }

    const createCountriesResetState = () => {
        dispatch({ type: 'CREATE_COUNTRIES_RESET_STATE' });
    }

    const updateCountriesById = (id, data) => {
        dispatch({ type: 'UPDATE_COUNTRIES_BY_ID_LOADING' });

        let db = firestoreInitialize();

        db.collectionGroup('Configuraciones')
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((document) => {
                    document.ref.collection("Paises").doc(id).update({
                        nombre: data.name,
                        status: data.status,
                        codigoTelefono: data.code
                    })
                    .then(() => {
                        dispatch({ type: 'UPDATE_COUNTRIES_BY_ID' })
                    })
                })
            })
            .catch((error) => dispatch({ type: 'UPDATE_COUNTRIES_BY_ID_ERROR', payload: { code: 'countries/error', message: error } }))
    };

    const createCurrenciesByCountry = (id, data) => {
        dispatch({ type: 'CREATE_CURRENCIES_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.icon) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.icon.name}`).put(data.icon, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'CREATE_CURRENCIES_ERROR', payload: { code: 'currencies/error', message: error } })
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collectionGroup('Configuraciones')
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((document) => {
                            document.ref.collection("Paises").doc(id).get().then((querySnapshot) => {
                                querySnapshot.ref.collection("Monedas").add({
                                    nombre: data.name,
                                    simbolo: data.simbol,
                                    status: data.status,
                                    icono: downloadURL
                                })
                                .then((doc) => {
                                    querySnapshot.ref.collection("Monedas").doc(doc.id).update({
                                        monedaId: doc.id
                                    })
                                    .then(() => {
                                        dispatch({ type: 'CREATE_CURRENCIES' })
                                    })
                                })
                            })
                        })
                    })
                    .catch((error) => dispatch({ type: 'CREATE_CURRENCIES_ERROR', payload: { code: 'currencies/error', message: error } }))
                });
            });
        } else {
            db.collectionGroup('Configuraciones')
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((document) => {
                    document.ref.collection("Paises").doc(id).get().then((querySnapshot) => {
                        querySnapshot.ref.collection("Monedas").add({
                            nombre: data.name,
                            simbolo: data.simbol,
                            status: data.status,
                            icono: ""
                        })
                        .then((doc) => {
                            querySnapshot.ref.collection("Monedas").doc(doc.id).update({
                                monedaId: doc.id
                            })
                            .then(() => {
                                dispatch({ type: 'CREATE_CURRENCIES' })
                            })
                        })
                    })
                })
            })
            .catch((error) => dispatch({ type: 'CREATE_CURRENCIES_ERROR', payload: { code: 'currencies/error', message: error } }))
        }
    };

    const updateCurrenciesById = (countryId, currencyId, data) => {
        dispatch({ type: 'UPDATE_CURRENCIES_BY_ID_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.icon) {
            console.log('ejecuta')
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.icon.name}`).put(data.icon, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'UPDATE_CURRENCIES_BY_ID_ERROR', payload: { code: 'product/update-error', message: error } });
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collectionGroup('Configuraciones')
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((document) => {
                            document.ref.collection("Paises").doc(countryId).get().then((querySnapshot) => {
                                querySnapshot.ref.collection("Monedas").doc(currencyId).update({
                                    nombre: data.name,
                                    simbolo: data.simbol,
                                    status: data.status,
                                    icono: downloadURL
                                })
                                .then(() => {
                                    dispatch({ type: 'UPDATE_CURRENCIES_BY_ID' })
                                })
                            })
                        })
                    })
                    .catch((error) => dispatch({ type: 'UPDATE_CURRENCIES_BY_ID_ERROR', payload: { code: 'currencies/error', message: error } }))
                });
            });
        } else {
            if (data.deleteIcon && data.iconPath.length > 0) {
                let storageRef = storage.refFromURL(data.iconPath);

                storageRef.delete().then(function() {
                    db.collectionGroup('Configuraciones')
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((document) => {
                            document.ref.collection("Paises").doc(countryId).get().then((querySnapshot) => {
                                querySnapshot.ref.collection("Monedas").doc(currencyId).update({
                                    nombre: data.name,
                                    simbolo: data.simbol,
                                    status: data.status,
                                    icono: ""
                                })
                                .then(() => {
                                    dispatch({ type: 'UPDATE_CURRENCIES_BY_ID' })
                                })
                            })
                        })
                    })
                    .catch((error) => dispatch({ type: 'UPDATE_CURRENCIES_BY_ID_ERROR', payload: { code: 'currencies/error', message: error } }))
                }).catch(function(error) {
                    dispatch({ type: 'UPDATE_CURRENCIES_BY_ID_ERROR', payload: { code: 'currencies/update-error', message: error } });
                });
            } else {
                db.collectionGroup('Configuraciones')
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((document) => {
                            document.ref.collection("Paises").doc(countryId).get().then((querySnapshot) => {
                                querySnapshot.ref.collection("Monedas").doc(currencyId).update({
                                    nombre: data.name,
                                    simbolo: data.simbol,
                                    status: data.status
                                })
                                .then(() => {
                                    dispatch({ type: 'UPDATE_CURRENCIES_BY_ID' })
                                })
                            })
                        })
                    })
                    .catch((error) => dispatch({ type: 'UPDATE_CURRENCIES_BY_ID_ERROR', payload: { code: 'currencies/error', message: error } }))
            }
        }
    };

    const getCitiesByCountry = (country) => {
        dispatch({ type: 'GET_CITIES_BY_COUNTRY_LOADING' });

        let db = firestoreInitialize();

        db.collection('Ciudades').doc(country)
            .get()
            .then((querySnapshot) => {
                dispatch({ type: 'GET_CITIES_BY_COUNTRY', payload: querySnapshot.data()});
            })
            .catch((error) => dispatch({ type: 'GET_CITIES_BY_COUNTRY_ERROR', payload: { code: 'countries/error', message: error } }))
    };

    const createCitiesByCountry = (data) => {
        dispatch({ type: 'CREATE_CITIES_BY_COUNTRY_LOADING' })

        let db = firestoreInitialize();

        db.collectionGroup('Configuraciones')
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((document) => {
                    document.ref.collection("Paises").doc(data.country).get().then((querySnapshot) => {
                        querySnapshot.ref.collection("Ciudades").add({
                            nombre: data.name
                        }).then((doc) => {
                            querySnapshot.ref.collection("Ciudades").doc(doc.id).update({
                                ciudadId: doc.id
                            }).then(() => {
                                dispatch({ type: 'CREATE_CITIES_BY_COUNTRY' })
                            }).catch((error) => dispatch({ type: 'CREATE_CITIES_BY_COUNTRY_ERROR', payload: { code: 'cities/create-error', message: error } }))
                        })
                    })
                })
            })
            .catch((error) => dispatch({ type: 'CREATE_CITIES_BY_COUNTRY_ERROR', payload: { code: 'cities/create-error', message: error } }))
    };

    const updateCitiesByCountry = (country, city, data) => {
        dispatch({ type: 'UPDATE_CITIES_BY_COUNTRY_LOADING' })

        let db = firestoreInitialize();

        db.collectionGroup('Configuraciones')
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((document) => {
                    document.ref.collection("Paises").doc(country).get().then((querySnapshot) => {
                        querySnapshot.ref.collection("Ciudades").doc(city).update({
                            nombre: data.name
                        }).then(() => {
                            dispatch({ type: 'UPDATE_CITIES_BY_COUNTRY' })
                        }).catch((error) => dispatch({ type: 'UPDATE_CITIES_BY_COUNTRY_ERROR', payload: { code: 'cities/update-error', message: error } }))
                    })
                })
            })
            .catch((error) => dispatch({ type: 'UPDATE_CITIES_BY_COUNTRY_ERROR', payload: { code: 'cities/update-error', message: error } }))
    };

    const updateResetCountries = () => {
        dispatch({ type: 'UPDATE_COUNTRIES_RESET_STATE' });
    };

    return (
        <SettingsBaseContext.Provider value={{
            settingsBaseState: state.getSettingsBase,
            updateSettingsBaseState: state.updateSettingsBase,
            countriesState: state.getCountries,
            countriesByIdState: state.getCountriesById,
            createCountriesState: state.createCountries,
            updateCountriesByIdState: state.updateCountriesById,
            currenciesByCountryState: state.getCurrenciesByCountry,
            createCurrenciesByCountryState: state.createCurrenciesByCountry,
            updateCurrenciesByIdState: state.updateCurrenciesById,
            citiesByCountryState: state.getCitiesByCountry,
            createCitiesByCountryState: state.createCitiesByCountry,
            updateCitiesByCountryState: state.updateCitiesByCountry,
            getSettingsBase,
            updateSettingsBase,
            updateSettingsBaseResetState,
            getCountries,
            createCountries,
            createCountriesWithExcel,
            createCountriesResetState,
            updateCountriesById,
            getCurrenciesByCountry,
            createCurrenciesByCountry,
            updateCurrenciesById,
            updateResetCountries,
            getCitiesByCountry,
            createCitiesByCountry,
            updateCitiesByCountry
        }}>
            {props.children}
        </SettingsBaseContext.Provider>
    )
}

export default SettingsBaseState;
